// Translation Manager API surface.

import type {
  ListTranslationsQuery,
  PublishTranslationStringsInput,
  TranslationKeyDto,
  TranslationNamespaceDto,
  TranslationStringDto,
  UpsertTranslationStringInput,
} from '@fajrarabi/zod-schemas/translations';

import { api } from './api';

export async function listNamespaces(signal?: AbortSignal): Promise<TranslationNamespaceDto[]> {
  const { namespaces } = await api<{ namespaces: TranslationNamespaceDto[] }>(
    '/admin/translations/namespaces',
    { signal },
  );
  return namespaces;
}

export async function listKeys(
  query: Partial<ListTranslationsQuery> = {},
  signal?: AbortSignal,
): Promise<{ keys: TranslationKeyDto[]; total: number }> {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(query)) {
    if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  }
  const suffix = qs.size > 0 ? `?${qs.toString()}` : '';
  return api(`/admin/translations/keys${suffix}`, { signal });
}

export async function upsertString(
  input: UpsertTranslationStringInput,
): Promise<TranslationStringDto> {
  const { string } = await api<{ string: TranslationStringDto }>('/admin/translations/strings', {
    method: 'PUT',
    body: input,
  });
  return string;
}

export async function publishStrings(
  input: PublishTranslationStringsInput,
): Promise<{ published: number }> {
  return api('/admin/translations/strings/publish', { method: 'POST', body: input });
}

export async function getKeyHistory(key: string): Promise<
  Array<{
    id: string;
    action: string;
    actorUserId: string | null;
    metadata: unknown;
    createdAt: string;
  }>
> {
  const { events } = await api<{
    events: Array<{
      id: string;
      action: string;
      actorUserId: string | null;
      metadata: unknown;
      createdAt: string;
    }>;
  }>(`/admin/translations/strings/${encodeURIComponent(key)}/history`);
  return events;
}
